export const getTypeByTrigger = (trigger: string) =>
  trigger === '@' ? 'mention' : `${trigger}mention`
